import { useState, useEffect } from "react";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";

function SetPagination({ list_page, count, type, search_term }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [listingsPerPage, setListingsPerPage] = useState(5);

  useEffect(() => {
    if (type === "small") {
      setListingsPerPage(5);
    } else if (type === "medium") {
      setListingsPerPage(9);
    } else if (type === "large") {
      setListingsPerPage(18);
    }
  }, [type]);

  const totalPages = Math.ceil(count / listingsPerPage);

  const visitPage = (page) => {
    setCurrentPage(page);
    list_page(page, search_term);
  };

  const previous_number = () => {
    if (currentPage > 1) {
      visitPage(currentPage - 1);
    }
  };

  const next_number = () => {
    if (currentPage < totalPages) {
      visitPage(currentPage + 1);
    }
  };

  return (
    <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
      {/* Mobile Navigation */}
      <div className="flex flex-1 justify-between sm:hidden">
        <button
          onClick={previous_number}
          disabled={currentPage === 1}
          className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
        >
          Previous
        </button>
        <button
          onClick={next_number}
          disabled={currentPage === totalPages}
          className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
        >
          Next
        </button>
      </div>

      {/* Desktop Navigation */}
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700">
            Showing{" "}
            <span className="font-medium">
              {(currentPage - 1) * listingsPerPage + 1}
            </span>{" "}
            to{" "}
            <span className="font-medium">
              {Math.min(currentPage * listingsPerPage, count)}
            </span>{" "}
            of <span className="font-medium">{count}</span> results
          </p>
        </div>
        <div>
          <nav
            className="isolate inline-flex -space-x-px rounded-md shadow-sm"
            aria-label="Pagination"
          >
            <button
              onClick={previous_number}
              disabled={currentPage === 1}
              className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:opacity-50"
            >
              <span className="sr-only">Previous</span>
              <IconChevronLeft className="h-5 w-5" />
            </button>
            {[...Array(totalPages).keys()].map((page) => (
              <button
                key={page + 1}
                onClick={() => visitPage(page + 1)}
                aria-current={currentPage === page + 1 ? "page" : undefined}
                className={`relative inline-flex items-center px-4 py-2 text-sm font-medium ${
                  currentPage === page + 1
                    ? "z-10 bg-indigo-600 text-white focus:z-20"
                    : "text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20"
                }`}
              >
                {page + 1}
              </button>
            ))}
            <button
              onClick={next_number}
              disabled={currentPage === totalPages}
              className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:opacity-50"
            >
              <span className="sr-only">Next</span>
              <IconChevronRight className="h-5 w-5" />
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default SetPagination;
